import { calculateAge } from "./calculateAge";
import { getAddressFields } from "../customerAddressFields";

export function adaptContactRecord(
  record: Record<string, unknown>
): Record<string, unknown> {
  const primaryAddress = getAddressFields(record, "1");
  const secondaryAddress = getAddressFields(record, "2");
  const birthdate = record.birthdate as string | Date | null | undefined;
  const age = birthdate ? calculateAge(birthdate) : undefined;

  if (!primaryAddress && !secondaryAddress && age === undefined) {
    return record;
  }

  return {
    ...record,
    ...(primaryAddress ?? {}),
    ...(secondaryAddress ?? {}),
    ...(age !== undefined ? { g4_age: age } : {}),
  };
}
